import { createSlice } from "@reduxjs/toolkit";
import nicknamesSanitization, {
  addToBannedNames,
  loadInitListOfBannedNames,
} from "@axvdex/utils/nicknamesSanitization";
import state from "./initialOutbidState";

export const outbidSlice = createSlice({
  name: "outbid",
  initialState: state,
  reducers: {
    clearOutbid: state => {
      state.initLoading = true;
      state.nicknames = {};
      state.outbids = {};
      state.outbidAssets = {};
      state.outbidContracts = {};
      state.outbidServerTime = null;
      state.outbidUser = {
        salesBids: null,
        outbidAssetBalances: {},
      };
    },
    outbidFinishInitLoading: state => {
      state.initLoading = false;
    },
    updateOutbidAssets: (state, action) => {
      state.outbidAssets = { ...state.outbidAssets, ...action.payload };
    },
    updateWsOutbidContract: (state, action) => {
      if (state.outbidContracts[action.payload.label]) {
        if (action.payload.extraFields)
          state.outbidContracts = {
            ...state.outbidContracts,
            [action.payload.label]: {
              ...state.outbidContracts[action.payload.label],
              extraFields: action.payload.extraFields,
            },
          };
        if ("nicknames" === action.payload.label) {
          if (action.payload.extraFields?.uiToUpdate && action.payload.extraFields.uiToUpdate.length > 0) {
            const info = {};
            action.payload.extraFields.uiToUpdate.forEach(uiToUpdate => {
              const data = JSON.parse(uiToUpdate);
              info[data.address] = data.info;
            });
            state.nicknames = {
              ...state.nicknames,
              ...nicknamesSanitization(info),
            };
          }
          // when someone is banned, the BE emits an event with newBannedNickname field
          if (action.payload.newBannedNickname) {
            addToBannedNames(action.payload.newBannedNickname);
            state.nicknames = {
              ...nicknamesSanitization({
                ...state.nicknames,
              }),
            };
          }
        }
      }
    },
    updateWsOutbidSaleFields: (state, action) => {
      // only update the fields if the item already exists on state
      if (state.outbids[action.payload.label] && action.payload.saleAddress) {
        state.outbids = {
          ...state.outbids,
          [action.payload.label]: {
            ...state.outbids[action.payload.label],
            salesState: {
              ...state.outbids[action.payload.label].salesState,
              [action.payload.saleAddress]: action.payload.saleState,
            },
          },
        };
      }
      state.outbidServerTime = action.payload.serverTime;
    },
    updateWsServerTimeField: (state, action) => {
      state.outbidServerTime = action.payload;
    },
    updateOutbidSales: (state, action) => {
      state.outbids = action.payload;
    },
    updateOutbidServerTime: (state, action) => {
      state.outbidServerTime = action.payload;
    },
    updateNicknames: (state, { payload }) => {
      state.nicknames = {
        ...state.nicknames,
        ...nicknamesSanitization(payload),
      };
    },
    updateOutbidContracts: (state, action) => {
      state.outbidContracts = action.payload;
      if (
        action.payload.nicknames?.addedFields?.bannedNicknames &&
        JSON.parse(atob(action.payload.nicknames?.addedFields?.bannedNicknames)).length > 0
      ) {
        loadInitListOfBannedNames(JSON.parse(atob(action.payload.nicknames?.addedFields?.bannedNicknames)));
      }
    },
    setUserSalesBids: (state, { payload }) => {
      state.outbidUser = {
        ...state.outbidUser,
        salesBids: {
          ...state.outbidUser.salesBids,
          [payload.saleAddress]: payload.saleUserBids,
        },
      };
    },
    updateOutbidAssetBalances: (state, action) => {
      state.outbidUser = {
        ...state.outbidUser,
        outbidAssetBalances: { ...state.outbidUser.outbidAssetBalances, ...action.payload },
      };
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  outbidFinishInitLoading,
  clearOutbid,
  updateWsOutbidSaleFields,
  updateWsServerTimeField,
  updateOutbidSales,
  updateOutbidServerTime,
  updateNicknames,
  updateOutbidAssets,
  updateWsOutbidContract,
  updateOutbidContracts,
  setUserSalesBids,
  updateOutbidAssetBalances,
} = outbidSlice.actions;

export default outbidSlice.reducer;
